import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  Typography,
  TextField,
  Button,
  Modal,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Grid,
  CircularProgress,
} from '@mui/material';
import { Cropper } from 'react-image-cropper';
import photoCamera from 'styles/assets/icons/icon-camera.png';
import placeholderItem from 'styles/assets/placeholder/placeholder.gif';
import placeholderThumb from 'styles/assets/placeholder/placeholderThumbTriibo.png';
import logoThumb from 'styles/assets/placeholder/placeholderLogo.png';

import { getLastUserInfo } from 'js/library/utils/helpers';
import { insertOrUpdateOrg } from 'js/library/utils/API/insertOrUpdateOrg.js';

import { downloadImage } from 'js/library/services/StorageManager.js';

export const EditOrgInfo = (info) => {
  const { t } = useTranslation();

  const [logoFile, setLogoFile] = React.useState(logoThumb);
  const [coverImageFile, setCoverImageFile] = React.useState(placeholderItem);
  const [thumbnailFile, setThumbnailFile] = React.useState(placeholderThumb);
  const [imgToCrop, setimgToCrop] = React.useState(null);
  const [imgCropped, setImgCropped] = React.useState(null);
  const [modal, setModal] = React.useState(false);
  const [name, setName] = React.useState(info.orgInfo.name);
  const [description, setDescription] = React.useState(info.orgInfo.description);
  const [accessMethod, setAccessMethod] = React.useState(info.orgInfo.accessMethod);
  const [visible, setVisible] = React.useState(info.orgInfo.visible);
  const [formChanged, setFormChanged] = React.useState(false);
  const [modalEdit, setModalEdit] = React.useState(false);
  const [newLogo, setNewLogo] = React.useState(false);
  const [newCoverImage, setNewCoverImage] = React.useState(false);
  const [newThumbnail, setNewThumbnail] = React.useState(false);

  const [type, setType] = React.useState(null);
  const [ratio, setRatio] = React.useState(4 / 4);

  const [load, setLoad] = React.useState(false);

  const oldCoverImage = info.orgInfo.coverImage;
  const oldThumbnail = info.orgInfo.thumbnail;
  const oldLogo = info.orgInfo.logoImage;

  function getModalStyle() {
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      height: '70%',
      width: '60%',
      backgroundColor: 'white',
      padding: '30px',
      overflowY: 'auto',
    };
  }

  function getModalStyleEdit() {
    return {
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      position: 'absolute',
      backgroundColor: 'white',
      padding: '30px',
    };
  }

  function downloadImageOnLoad(type, data) {
    if (
      data !== null &&
      data !== undefined &&
      ((type === 'thumbnail' && thumbnailFile === placeholderThumb) ||
        (type === 'coverImage' && coverImageFile === placeholderItem) ||
        (type === 'logoImage' && logoFile === logoThumb))
    ) {
      const img = data.split('/');

      downloadImage(img[0], img[1])
        .then((downloaded) => {
          if (type === 'logoImage') {
            setLogoFile(downloaded);
          } else if (type === 'thumbnail') {
            setThumbnailFile(downloaded);
          } else {
            setCoverImageFile(downloaded);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }

  function fileChangehandler(event, type) {
    setRatio(type === 'thumbnail' ? 4 / 4 : type === 'logoImage' ? 95 / 12 : 4 / 3);
    setimgToCrop([URL.createObjectURL(event.target.files[0])]);
    setModal(true);
    setType(type);
  }

  function cropImage() {
    if (type === 'logoImage') {
      setLogoFile(imgCropped.crop());
      setNewLogo(true);
    } else if (type === 'thumbnail') {
      setThumbnailFile(imgCropped.crop());
      setNewThumbnail(true);
    } else {
      setCoverImageFile(imgCropped.crop());
      setNewCoverImage(true);
    }

    setModal(false);
  }

  function saveForm() {
    setLoad(true);
    const userInfo = getLastUserInfo();
    let newInfo = { orgID: info.orgInfo.orgID, name, description, accessMethod, visible };

    if (newLogo) {
      newInfo.logoImage = 'organizations/' + info.orgInfo.orgID + ':logoImage';
    }

    if (newCoverImage) {
      newInfo.coverImage = 'organizations/' + info.orgInfo.orgID + ':coverImage';
    }

    if (newThumbnail) {
      newInfo.thumbnail = 'organizations/' + info.orgInfo.orgID + ':thumbnail';
    }

    insertOrUpdateOrg(
      userInfo.uId,
      newInfo,
      newCoverImage,
      coverImageFile,
      oldCoverImage,
      newThumbnail,
      thumbnailFile,
      oldThumbnail,
      newLogo,
      logoFile,
      oldLogo
    ).then((result) => {
      info.handleEdit(null);
    });
  }

  return (
    <div>
      {load ? (
        <div style={{ textAlign: 'center' }} className="loading-content">
          <CircularProgress />
        </div>
      ) : (
        <div>
          <Typography
            style={{ color: '#0089FF', cursor: 'pointer' }}
            variant="body2"
            onClick={() => info.handleEdit(null)}
          >
            {'<'} {t('organizations.return')}
          </Typography>

          <Typography variant="subtitle1" color="primary">
            {t('organizations.triibo_logo')}
          </Typography>

          <label
            htmlFor="logoImage"
            style={{ width: '50%', cursor: 'pointer', display: 'block', position: 'relative' }}
          >
            <img
              src={photoCamera}
              style={{
                padding: 10,
                borderBottomLeftRadius: 10,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                right: 0,
                top: 0,
                position: 'absolute',
              }}
              alt="icon cover"
            />
            <img
              src={logoFile}
              alt="thubmnail"
              width="100%"
              onLoad={() => downloadImageOnLoad('logoImage', info.orgInfo.logoImage)}
            />
          </label>
          <input
            value=""
            style={{ display: 'none' }}
            type="file"
            accept=".png,.jpg"
            onChange={(e) => fileChangehandler(e, 'logoImage')}
            id="logoImage"
          />

          <Typography variant="subtitle1" color="primary">
            {t('organizations.triibo_icon')}
          </Typography>

          <label
            htmlFor="thumbnailImage"
            style={{ width: '50%', cursor: 'pointer', display: 'block', position: 'relative' }}
          >
            <img
              src={photoCamera}
              style={{
                padding: 10,
                borderBottomLeftRadius: 10,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                right: 0,
                top: 0,
                position: 'absolute',
              }}
              alt="icon cover"
            />
            <img
              src={thumbnailFile}
              alt="thubmnail"
              width="100%"
              onLoad={() => downloadImageOnLoad('thumbnail', info.orgInfo.thumbnail)}
            />
          </label>
          <input
            value=""
            style={{ display: 'none' }}
            type="file"
            accept=".png,.jpg"
            onChange={(e) => fileChangehandler(e, 'thumbnail')}
            id="thumbnailImage"
          />

          <Typography variant="subtitle1" color="primary">
            {t('organizations.cover_image')}
          </Typography>

          <label
            htmlFor="coverImage"
            style={{ width: '100%', cursor: 'pointer', display: 'block', position: 'relative' }}
          >
            <img
              src={photoCamera}
              style={{
                padding: 10,
                borderBottomLeftRadius: 10,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                right: 0,
                top: 0,
                position: 'absolute',
              }}
              alt="icon cover"
            />
            <img
              src={coverImageFile}
              alt="thubmnail"
              width="100%"
              onLoad={() => downloadImageOnLoad('coverImage', info.orgInfo.coverImage)}
            />
          </label>
          <input
            value=""
            style={{ display: 'none' }}
            type="file"
            accept=".png,.jpg"
            onChange={(e) => fileChangehandler(e, 'coverImage')}
            id="coverImage"
          />

          <br />
          <br />

          <TextField
            id="name"
            onChange={(e) => {
              setName(e.target.value);
              setFormChanged(true);
            }}
            label="Nome"
            value={name}
            variant="outlined"
            fullWidth
          />

          <br />
          <br />

          <TextField
            id="name"
            onChange={(e) => {
              setDescription(e.target.value);
              setFormChanged(true);
            }}
            label="Descrição"
            value={description}
            variant="outlined"
            multiline
            fullWidth
          />

          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              {t('organizations.access_to_triibo')}
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={accessMethod}
              onChange={(e) => {
                setAccessMethod(e.target.value);
                setFormChanged(true);
              }}
            >
              <MenuItem value="public">{t('organizations.open_to_all')}</MenuItem>
              <MenuItem value="private">{t('organizations.admin_acceptance')}</MenuItem>
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                name="visible"
                checked={visible}
                onChange={(e) => {
                  setVisible(e.target.checked);
                  setFormChanged(true);
                }}
              />
            }
            label={t('organizations.triibo_visible_to_all')}
          />

          <Grid container spacing={4} style={{ width: '100%' }}>
            <Grid size={{ md: 6, xs: 12 }}>
              <Button
                fullWidth
                onClick={formChanged ? () => setModalEdit(true) : () => info.handleEdit(null)}
                variant="contained"
                color="secondary"
                style={{ textTransform: 'none' }}
              >
                {t('organizations.cancel')}
              </Button>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }}>
              <Button
                fullWidth
                onClick={() => saveForm()}
                variant="contained"
                color="primary"
                style={{ textTransform: 'none' }}
              >
                {t('organizations.save')}
              </Button>
            </Grid>
          </Grid>

          {/* MODAL PARA CROPAR IMAGEM */}
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={modal}
          >
            <div style={getModalStyle()}>
              <Typography variant="h5" gutterBottom color="primary" style={{ fontWeight: '600' }}>
                {t('organizations.edit_image')}
              </Typography>
              <div style={{ marginBottom: 15 }}>
                <Button
                  style={{ color: 'white', textTransform: 'none' }}
                  variant="contained"
                  color="secondary"
                  onClick={() => setModal(false)}
                >
                  {t('organizations.cancel')}
                </Button>

                <Button
                  style={{ marginLeft: '10px', color: 'white', textTransform: 'capitalize' }}
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    cropImage();
                    setFormChanged(true);
                  }}
                >
                  {t('organizations.crop_image')}
                </Button>
              </div>
              <div style={{ maxWidth: '70%', marginLeft: 'auto', marginRight: 'auto' }}>
                {imgToCrop === null ? null : (
                  <Cropper src={imgToCrop[0]} ref={(ref) => setImgCropped(ref)} ratio={ratio} />
                )}
              </div>
            </div>
          </Modal>
          {/* FIM MODAL PARA CROPAR IMAGEM */}

          {/* MODAL CANCELAR EDIÇÃO */}
          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={modalEdit}
          >
            <div style={getModalStyleEdit()}>
              <Typography variant="h6" gutterBottom color="primary" style={{ fontWeight: '600' }}>
                {t('organizations.cancel_edition_warning')}
              </Typography>

              <Grid container spacing={4} style={{ width: '100%' }}>
                <Grid size={{ md: 6, xs: 12 }}>
                  <Button
                    fullWidth
                    onClick={() => setModalEdit(false)}
                    variant="contained"
                    color="secondary"
                    style={{ textTransform: 'none' }}
                  >
                    {t('organizations.continue_editing')}
                  </Button>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                  <Button
                    fullWidth
                    onClick={() => info.handleEdit(null)}
                    variant="contained"
                    color="primary"
                    style={{ textTransform: 'none' }}
                  >
                    {t('organizations.cancel_editing')}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Modal>
          {/* FIM MODAL CANCELAR EDIÇÃO */}
        </div>
      )}
    </div>
  );
};
export default EditOrgInfo;
